import { isAndroid } from './is-android';

export function flashVersion(): number {

    if (isAndroid()) {
        return 0;
    }

    const plugins = navigator.plugins;
    let flash;

    if (plugins) {
        flash = plugins['Shockwave Flash'];
        if (flash && flash.description) {
            return parseFloat(flash.description.replace(/\D+(\d+\.?\d*).*/, '$1'));
        }
    }

    if (typeof window['ActiveXObject'] !== 'undefined') {
        try {
            flash = new window['ActiveXObject']('ShockwaveFlash.ShockwaveFlash');
            if (flash) {
                return parseFloat(flash.GetVariable('$version').split(' ')[1].replace(/\s*,\s*/, '.'));
            }
        } catch (e) {
            return 0;
        }

        return flash;
    }
    return 0;
}
